export default __webpack_public_path__ + "static/media/manual10.c29fb481.png";